import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'

const useCabinetInit = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.type === 'init') {
        return http.post(`/cabinets/${data.cabinet_id}/commands/${data.type}`, {
          id: Number(data.cabinet_id),
        })
      } else {
        return http.post(`/cabinets/commands`, {
          object_ids: [Number(data.cabinet_id)],
          type: data.type,
        })
      }
    },
  })

  const send = async (type: string, cabinetId: number = 0) => {
    const data = {
      type: type,
      cabinet_id: cabinetId || route.params.object_id,
    }

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}

export { useCabinetInit }
